import { Component } from '@angular/core'
import { SpinnerComponent } from 'src/app/public/spinner/spinner.component'

@Component({
  selector: '[app-select-menu-list-loading-item]',
  imports: [SpinnerComponent],
  template: `
    <div class="spinner-container">
      <app-spinner></app-spinner>
    </div>
    `,
  styles: `
    :host {
      position: relative;
      height: 6rem;
    }

    .spinner-container {
      position: absolute;
      left: calc(50% - 2rem);
      top: 1rem;
    }
    `,
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class SelectMenuListloadingComponent {}
